const downloadBase64AsFile = (base64, fileName, mime) => {
  const linkSource = `data:${mime};base64,${base64}`;
  // eslint-disable-next-line no-undef
  const downloadLink = document.createElement("a");

  downloadLink.href = linkSource;
  downloadLink.download = fileName;
  downloadLink.click();
  downloadLink.remove();
};

const downloadStreamAsFile = (stream, fileName) => {
  // eslint-disable-next-line no-undef
  const file = new Blob([stream]);
  const fileURL = URL.createObjectURL(file);

  // eslint-disable-next-line no-undef
  const downloadLink = document.createElement("a");

  downloadLink.href = fileURL;
  downloadLink.download = fileName;
  downloadLink.click();
  downloadLink.remove();
};

export { downloadBase64AsFile, downloadStreamAsFile };
